/**
 * @generated SignedSource<<f2af84d5adc0f9b927b2d6b399dc9e58>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HideItem_container$data = {
  readonly id?: string;
  readonly navigationItems?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly isDefault: boolean;
        readonly url: string | null | undefined;
      };
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "HideItem_container";
};
export type HideItem_container$key = {
  readonly " $data"?: HideItem_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"HideItem_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "HideItem_container",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "id"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            }
          ],
          "concreteType": "JiraNavigationItemConnection",
          "kind": "LinkedField",
          "name": "navigationItems",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraNavigationItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "kind": "ScalarField",
                          "name": "isDefault"
                        },
                        "action": "THROW",
                        "path": "navigationItems.edges.node.isDefault"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "url"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "navigationItems.edges.node"
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraContainerNavigation"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "74369dee0c0b32c1011fec3260d7a339";

export default node;
